
// import React, { useState } from "react";

// const DateTimeFilter = ({ closeModal }) => {
//   const [formData, setFormData] = useState({
//     pickupDate: "2024-10-10",
//     pickupTime: "12:00",
//     dropoffDate: "2024-10-10",
//     dropoffTime: "12:00",
//     rentDuration: "20 Hours",
//     category: "",
//     bikeModel: "",
//     location: "",
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Submitted Form Data:", formData);
//     // Add your submit logic here, e.g., API call or state update
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   return (
//     <>
//       <div className="flex justify-between mb-4 bg-[#FF9630] p-3 shadow-md">
//         <h2 className="text-xl font-semibold  text-white">Filter</h2>
//         <button
//           onClick={closeModal} // Close the modal when clicked
//           className="text-white hover:text-gray-900"
//         >
//           ✕
//         </button>
//       </div>
//       <form onSubmit={handleSubmit} className="p-4 bg-white rounded-md shadow-md w-full h-full max-w-md mx-auto sm:max-w-none sm:w-full sm:h-screen sm:overflow-y-auto">
//         {/* Header Section */}

//         <p className="text-xl font-semibold mb-2">Select date and Time</p>
//         {/* Pick-up Date & Time */}
//         <div className="mb-4 mt-4">
//           <label className="block text-md font-medium mb-1">Pick-up date</label>
//           <div className="flex space-x-2">
//             <input
//               type="date"
//               name="pickupDate"
//               value={formData.pickupDate}
//               onChange={handleChange}
//               className="flex-1 border bg-white rounded-md p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <select
//               name="pickupTime"
//               value={formData.pickupTime}
//               onChange={handleChange}
//               className="flex-1 border bg-white rounded-md p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             >
//               {["12:00", "1:00", "2:00", "3:00"].map((time) => (
//                 <option key={time} value={time}>
//                   {time} PM
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Drop-off Date & Time */}
//         <div className="mb-4">
//           <label className="block text-md font-medium mb-1">Drop-off date</label>
//           <div className="flex space-x-2">
//             <input
//               type="date"
//               name="dropoffDate"
//               value={formData.dropoffDate}
//               onChange={handleChange}
//               className="flex-1 border bg-white rounded-md p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <select
//               name="dropoffTime"
//               value={formData.dropoffTime}
//               onChange={handleChange}
//               className="flex-1 border rounded-md bg-white p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             >
//               {["12:00", "1:00", "2:00", "3:00"].map((time) => (
//                 <option key={time} value={time}>
//                   {time} PM
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Rent Duration */}
//         <div className="mb-4">
//           <label className="block text-md font-medium mb-1">Rent Duration</label>
//           <input
//             type="text"
//             name="rentDuration"
//             value={formData.rentDuration}
//             readOnly
//             className="w-full border rounded-md p-2 text-md bg-white focus:outline-none"
//           />
//         </div>

//         <div className="mb-4">
//           <select
//             name="category"
//             value={formData.category}
//             onChange={handleChange}
//             className="w-full border rounded-md p-2 text-md bg-white focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           >
//             <option value="" disabled>Select Category</option>
//             <option value="Category 1">Category 1</option>
//             <option value="Category 2">Category 2</option>
//           </select>
//         </div>

//         {/* Bike Models */}
//         <div className="mb-4">
//           <select
//             name="bikeModel"
//             value={formData.bikeModel}
//             onChange={handleChange}
//             className="w-full border rounded-md p-2 bg-white text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           >
//             <option value="" disabled>Select Bike Model</option>
//             <option value="Model 1">Model 1</option>
//             <option value="Model 2">Model 2</option>
//           </select>
//         </div>

//         {/* Location */}
//         <div className="mb-4">
//           <select
//             name="location"
//             value={formData.location}
//             onChange={handleChange}
//             className="w-full border rounded-md p-2 text-md  bg-white focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           >
//             <option value="" disabled>Select Location</option>
//             <option value="Location 1">Location 1</option>
//             <option value="Location 2">Location 2</option>
//           </select>
//         </div>

//         {/* Buttons */}
//         <div className="flex space-x-4 mt-60">
//           <button
//             type="button"
//             onClick={() =>
//               setFormData({
//                 pickupDate: "2024-10-10",
//                 pickupTime: "12:00",
//                 dropoffDate: "2024-10-10",
//                 dropoffTime: "12:00",
//                 rentDuration: "20 Hours",
//                 category: "",
//                 bikeModel: "",
//                 location: "",
//               })
//             }
//             className="flex-1 py-2 text-[#FF9630] border border-[#FF9630] rounded-md font-medium"
//           >
//             Reset All
//           </button>
//           <button
//             type="submit"
//             className="flex-1 py-2 bg-[#FF9630] text-white rounded-md font-medium"
//           >
//             Apply
//           </button>
//         </div>
//       </form>
//     </>
//   );
// };

// export default DateTimeFilter;



import React, { useState } from "react";
import MCategoryFilter from "./MCategories";
import MLocationFilter from "./MLocationFilter"; // Import LocationFilter
import MBikeModel from "./MBikeModel"; // Import BikeModel
import MSelectDuration from "./MSelectDuration"; // Import SelectDuration

const MDateTimeFilter = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    pickupDate: "2024-10-10",
    pickupTime: "12:00",
    dropoffDate: "2024-10-10",
    dropoffTime: "12:00",
    rentDuration: "20 Hours",
    category: "",
    bikeModel: "",
    location: "",
  });

  const [isCategoryModalOpen, setCategoryModalOpen] = useState(false);
  const [isLocationModalOpen, setLocationModalOpen] = useState(false); // State for Location Modal
  const [isBikeModelModalOpen, setBikeModelModalOpen] = useState(false); // State for Bike Model Modal
  const [isDurationModalOpen, setDurationModalOpen] = useState(false); // State for Duration Modal


  const handleCategoryModalToggle = () => {
    setCategoryModalOpen((prev) => !prev);
  };

  const handleLocationModalToggle = () => {
    setLocationModalOpen((prev) => !prev);
  };

  const handleBikeModelModalToggle = () => {
    setBikeModelModalOpen((prev) => !prev);
  };

  const handleDurationModalToggle = () => {
    setDurationModalOpen((prev) => !prev);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const newData = { ...prevData, [name]: value };
      return { ...newData, rentDuration: calculateDuration(newData) };
    });
  };

  const handleLocationSelect = (selectedLocations) => {
    setFormData((prevData) => ({
      ...prevData,
      location: selectedLocations.join(", "),
    }));
    setLocationModalOpen(false);
  };

  const handleBikeModelSelect = (selectedBikeModels) => {
    setFormData((prevData) => ({
      ...prevData,
      bikeModel: selectedBikeModels.join(", "),
    }));
    setBikeModelModalOpen(false);
  };

  const handleCategorySelect = (selectedCategories) => {
    setFormData((prevData) => ({
      ...prevData,
      category: selectedCategories.join(", "),
    }));
  };

  const calculateDuration = ({ pickupDate, pickupTime, dropoffDate, dropoffTime }) => {
    const pickup = new Date(`${pickupDate}T${pickupTime}`);
    const dropoff = new Date(`${dropoffDate}T${dropoffTime}`);

    if (dropoff < pickup) return "Invalid duration";

    const diffInMs = dropoff - pickup;
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${diffInHours} Hours ${diffInMinutes} Minutes`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Form Data:", formData);
  };
  return (
    <>
      <div className="flex justify-between mb-4 bg-[#FF9630] p-3 shadow-md">
        <h2 className="text-xl font-semibold  text-white">Filter</h2>
        <button
          onClick={closeModal} // Close the modal when clicked
          className="text-white hover:text-gray-900"
        >
          ✕
        </button>
      </div>
      <form onSubmit={handleSubmit} className="p-4 bg-white rounded-md shadow-md w-full h-full max-w-md mx-auto sm:max-w-none sm:w-full sm:h-screen sm:overflow-y-auto">
        {/* Header Section */}

        <p className="text-xl font-semibold mb-2">Select date and Time</p>

        <div className="mb-4 mt-4">
          <label className="block text-md font-medium mb-1">Pick-up Date</label>
          <div className="flex space-x-2">
            <input
              type="date"
              name="pickupDate"
              value={formData.pickupDate}
              onChange={handleChange}
              className="flex-1 border bg-white rounded-md p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <input
              type="time"
              name="pickupTime"
              value={formData.pickupTime}
              onChange={handleChange}
              className="flex-1 border bg-white rounded-md p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
          </div>
        </div>

        {/* Drop-off Date & Time */}
        <div className="mb-4">
          <label className="block text-md font-medium mb-1">Drop-off Date</label>
          <div className="flex space-x-2">
            <input
              type="date"
              name="dropoffDate"
              value={formData.dropoffDate}
              onChange={handleChange}
              className="flex-1 border bg-white rounded-md p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <input
              type="time"
              name="dropoffTime"
              value={formData.dropoffTime}
              onChange={handleChange}
              className="flex-1 border bg-white rounded-md p-2 text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
          </div>
        </div>

        {/* Rent Duration */}
        <div className="mb-4">
          <label className="block text-md font-medium mb-1">Select Duration</label>
          <div onClick={handleDurationModalToggle} className="cursor-pointer">
            <input
              type="text"
              name="rentDuration"
              value={formData.rentDuration}
              placeholder="Select Duration"
              readOnly
              className="w-full border rounded-md p-2 bg-white text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630] cursor-pointer"
            />
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-md font-medium mb-1">Category</label>
          <div onClick={handleCategoryModalToggle} className="cursor-pointer">
            <input
              type="text"
              name="category"
              value={formData.category}
              placeholder="Select Category"
              readOnly
              className="w-full border rounded-md p-2 bg-white text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630] cursor-pointer"
            />
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-md font-medium mb-1">Bike Model</label>
          <div onClick={handleBikeModelModalToggle} className="cursor-pointer">
            <input
              type="text"
              name="bikeModel"
              value={formData.bikeModel}
              placeholder="Select Bike Model"
              readOnly
              className="w-full border rounded-md p-2 bg-white text-md focus:outline-none focus:ring-2 focus:ring-[#FF9630] cursor-pointer"
            />
          </div>
        </div>

        {/* Location */}
        <div className="mb-4">
          <label className="block text-md font-medium mb-1">Location</label>
          <div onClick={handleLocationModalToggle} className="cursor-pointer">
            <input
              type="text"
              name="location"
              value={formData.location}
              placeholder="Select Location"
              readOnly
              className="w-full border rounded-md p-2 text-md bg-white focus:outline-none focus:ring-2 focus:ring-[#FF9630] cursor-pointer"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex space-x-4 mt-44">
          <button
            type="button"
            onClick={() =>
              setFormData({
                pickupDate: "2024-10-10",
                pickupTime: "12:00",
                dropoffDate: "2024-10-10",
                dropoffTime: "12:00",
                rentDuration: "20 Hours",
                category: "",
                bikeModel: "",
                location: "",
              })
            }
            className="flex-1 py-2 text-[#FF9630] border border-[#FF9630] rounded-md font-medium"
          >
            Reset All
          </button>
          <button
            type="submit"
            className="flex-1 py-2 bg-[#FF9630] text-white rounded-md font-medium"
          >
            Apply
          </button>
        </div>
      </form>
      {isLocationModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg">
            <MLocationFilter
              onSelect={handleLocationSelect} // Pass callback for location selection
            />
          </div>
        </div>
      )}
      {isCategoryModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg">
            <MCategoryFilter closeModal={handleCategoryModalToggle} />
          </div>
        </div>
      )}
      {isBikeModelModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg">
            <MBikeModel onSelect={handleBikeModelSelect} />
          </div>
        </div>
      )}
      {isDurationModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg">
            <MSelectDuration closeModal={handleDurationModalToggle} />
          </div>
        </div>
      )}
    </>
  );
};

export default MDateTimeFilter;
